import { Injectable } from '@angular/core';
import { HttpService } from '@symphony-solo/shared/http/src';
import { Observable } from 'rxjs';
import { TransactionReceiptResponseDto } from '../dtos';

@Injectable()
export class TransactionReceiptService {
  private path = 'transaction/receipt';
  constructor(private httpService: HttpService) {}

  public getTransactionReceipt(seq: number): Observable<Array<TransactionReceiptResponseDto>> {
    return this.httpService.makeGet<Array<TransactionReceiptResponseDto>>(`${this.path}/${seq}`);
  }
}
